module.exports = __webpack_public_path__ + "static/KL-cba200d4c3140ced48e8c10d89d85292.webm";